import { MdOutlineInventory2 } from "react-icons/md";
import { LuFactory } from "react-icons/lu";
import { StockData, StockHistory } from "@/pages/stocks";
import { StockHistoryData } from "@/pages/stock-history";
import {
    StockInitialData,
    StockInitialCreate,
    StockInitialEdit,
} from "@/pages/stock-initial";
import {
    StockAdjustmentData,
    StockAdjustmentCreate,
    StockAdjustmentEdit,
} from "@/pages/stock-adjustment";
import {
    ProductionData,
    ProductionCreate,
    ProductionEdit,
} from "@/pages/productions";

export const inventoryRoutes = {
    title: "PENYIMPANAN",
    type: "section",
    items: [
        {
            path: "/stocks",
            title: "Stok Gudang",
            icon: <MdOutlineInventory2 />,
            children: [
                {
                    path: "/stocks",
                    title: "Daftar Stok",
                    permission: "stock.view",
                    component: <StockData />,
                },
                {
                    path: "/stocks/history/warehouse/:warehouseId/material/:materialId/unit/:unitId",
                    title: "Riwayat Stok",
                    component: <StockHistory />,
                    permission: "stock.view",
                    type: "hidden",
                },
                {
                    path: "/stock-history",
                    title: "Riwayat Transaksi",
                    permission: "stock.view",
                    component: <StockHistoryData />,
                },
                {
                    path: "/stock-initial",
                    title: "Stok Awal",
                    permission: "stock-initial.view",
                    component: <StockInitialData />,
                },
                {
                    path: "/stock-initial/create",
                    title: "Tambah Stok Awal",
                    component: <StockInitialCreate />,
                    permission: "stock-initial.create",
                    type: "hidden",
                },
                {
                    path: "/stock-initial/edit/:id",
                    title: "Edit Stok Awal",
                    component: <StockInitialEdit />,
                    permission: "stock-initial.edit",
                    type: "hidden",
                },
                {
                    path: "/stock-adjustment",
                    title: "Penyesuaian Stok",
                    permission: "stock-adjustment.view",
                    component: <StockAdjustmentData />,
                },
                {
                    path: "/stock-adjustment/create",
                    title: "Tambah Penyesuaian Stok",
                    component: <StockAdjustmentCreate />,
                    permission: "stock-adjustment.create",
                    type: "hidden",
                },
                {
                    path: "/stock-adjustment/:batchId/edit",
                    title: "Edit Penyesuaian Stok",
                    component: <StockAdjustmentEdit />,
                    permission: "stock-adjustment.edit",
                    type: "hidden",
                },
            ],
        },
        {
            path: "/productions",
            title: "Produksi",
            icon: <LuFactory />,
            permission: "material-production.view",
            children: [
                {
                    path: "/productions/data",
                    title: "Riwayat Produksi",
                    component: <ProductionData />,
                },
                {
                    path: "/productions/create",
                    title: "Buat Produksi",
                    component: <ProductionCreate />,
                    permission: "material-production.create",
                    type: "hidden",
                },
                {
                    path: "/productions/:id/edit",
                    title: "Edit Produksi",
                    component: <ProductionEdit />,
                    permission: "material-production.edit",
                    type: "hidden",
                },
            ],
        },
    ],
};
